<template>
  <a
    target="_blank"
    :style="mystyle"
    :href="`http://wpa.qq.com/msgrd?v=3&uin=${qq}&site=qq&menu=yes`"
  >
    <slot v-if="custom"></slot>
    <img
      v-else
      border="0"
      :src="`http://wpa.qq.com/pa?p=2:${qq}:${type}`"
      alt="点击这里给我发消息"
      title="点击这里给我发消息"
    />
  </a>
</template>

<script>
export default {
  name: 'QQLinks',
  props: {
    qq: String,
    mystyle: String,
    custom: {
      type: Boolean,
      default: false,
    },
    type: {
      type: String,
      default: '52', // 51, 52, 53
    },
  },
}
</script>
